import { instantsInterceptor, } from '@/api/index';
import axios from "axios";
import { setInterceptors } from "@/api/common/interceptor";

function getRoleList(form) {
    return instantsInterceptor.post('/mgmt/role/list', form);
}

function getRole(roleId) {
    return instantsInterceptor.post('/mgmt/role/detail', { roleId: roleId });
}

function getRoleUser(roleId) {
    return instantsInterceptor.post('/mgmt/role/user', { roleId: roleId });
}

function saveRole(role) {
    return instantsInterceptor.post('/mgmt/role/save', role);
}

function deleteRoleList(roleList) {
    return instantsInterceptor.post('/mgmt/role/delete', roleList);
}

function saveUserRole(userList) {
    return instantsInterceptor.post('/mgmt/role/user/save', userList);
}

function deleteUserRole(userList) {
    return instantsInterceptor.post('/mgmt/role/user/delete', userList);
}

function downExcel() {
    let axiosInstance = axios.create({
        baseURL: process.env.VUE_APP_API_URL,
        headers: {
            'Access-Control-Allow-Origin': '*',
        },
        responseType: 'blob',
    });

    let instance = setInterceptors(axiosInstance);

    return instance.get('/mgmt/role/excel');
}

export {
    getRoleList,
    getRole,
    getRoleUser,
    saveRole,
    deleteRoleList,
    saveUserRole,
    deleteUserRole,
    downExcel
};